const context: AudioContext =
  'AudioContext' in global ? new global.AudioContext() :
  'webkitAudioContext' in global ? new (global as any).webkitAudioContext() :
  null

if (context == null) {
  throw new Error("Audio not enabled")
}

export default context